/**
 * Meta key con cui il pulsante di voto (VoteWidget) dichiara sul proprio schema
 * il tipo di votazione configurato. Letta da extractVotes per scegliere come
 * estrarre i voti: candidati per comitato (CTS) o liste elettorali (CS).
 */
export const VoteTypeMetaKey = 'voteType';
